/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Final_SubInputs */

const en_wc_final_sub = /** @type {(inputs: Wc_Final_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try WordCraft in the editor above, or download the desktop app for offline writing. Follow the beginner tutorial to create, format and save your first document.`)
};

/**
* | output |
* | --- |
* | "Try WordCraft in the editor above, or download the desktop app for offline writing. Follow the beginner tutorial to create, format and save your first document." |
*
* @param {Wc_Final_SubInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_final_sub = /** @type {((inputs?: Wc_Final_SubInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Final_SubInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_final_sub(inputs)
});
export { wc_final_sub as "wc.final.sub" }